/**
 * Reusable Reset Button Component
 */
import React from 'react';

export const ResetButton = ({ onClick, tooltip = 'Reset' }) => (
  <div className="projects-toolbar-reset relative group mr-[2%]">
    <svg 
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium text-red-700 hover:text-gray-500 cursor-pointer w-6 h-6 transition-colors duration-200" 
      focusable="false" 
      aria-hidden="true" 
      viewBox="0 0 24 24" 
      onClick={onClick}
    >
      <path 
        d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z" 
        fill="currentColor" 
      />
    </svg>
    <span className="absolute top-1/2 left-full -translate-y-1/2 ml-2 w-max px-2 py-1 bg-white text-red-700 text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200">
      {tooltip}
    </span>
  </div>
);

